module.exports = __webpack_public_path__ + "img/Sponga_Button.a2ea863a.png";